exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body[data-v-3477ae4a]{font-family:Verdana,Arial;margin:5px}", ""]);

// exports
